/**
* @file Display all available fieldsets (temporarily!)
* @author Heino Lenting
*/
import { FormControl, FormGroup } from '@angular/forms';
var FieldsetsAllComponent = /** @class */ (function () {
    function FieldsetsAllComponent() {
        this.form = null;
        this.checkBoxGroup = null;
        this.controls = {};
        this.repeatDummy = {
            Repeat: {
                kind: 'ONCE', factor: 1, cycles: -1, days: '', untilDate: new Date()
            },
            entityAspect: {
                entityState: {
                    isModified: function () { return true; },
                    isUnchanged: function () { return true; }
                }
            }
        };
        this.taskDummy = {
            start: new Date(),
            finish: new Date(),
            entityAspect: {
                getValidationErrors: function (name) {
                    return [];
                }
            },
            entityType: {},
            _Assignee: null,
            _Birthday: new Date(1981, 7, 13),
            _Boolean: true,
            _Checkboxes: 'AAP MIES',
            _Color: '#789ABC',
            _Date: new Date(2017, 8, 21),
            _Datetime: new Date(2001, 8, 11, 14, 46),
            _Duration: '8:43',
            _Email: 'info@symagic.com',
            _Emotion: 3,
            _Entity: null,
            _ProjectTask: null,
            _Message: 'This is my personal message',
            _List: { id: 1 },
            _Resources: [
                { id: 1, FirstName: 'Hans', LastName: 'van der Snoek', displayName: 'Hans van der Snoek' },
                { id: 2, FirstName: 'Wolf', LastName: 'Huijsen', displayName: 'Wolf Huijsen' },
                { id: 3, FirstName: 'Maarten', LastName: 'Lensink', displayName: 'Maarten Lensink' },
                { id: 4, FirstName: 'Peter', LastName: 'Brouwer', displayName: 'Peter Brouwer' },
                { id: 5, FirstName: 'Wim', LastName: 'Haanstra', displayName: 'Wim Haanstra' }
            ],
            _Facebook: 'piratenpartij',
            _File: 'https://s3.amazonaws.com/37assets/svn/1065-IMG_2529.jpg',
            _Google: '111618225726264790652',
            _Image: 'https://s3.amazonaws.com/37assets/svn/1065-IMG_2529.jpg',
            _Label: 'Label example',
            _Linkedin: 'maartencl',
            _Number: 678,
            _Currency: 920.50,
            _Signature: '',
            _Password: 'password123',
            _Phone: '+31612345678',
            _Radio: 'NOOT',
            _Select: 'MIES',
            _Skype: 'skypenick',
            _String: 'String example',
            _Text: 'Text example',
            _Time: new Date(2016, 11, 15, 13, 28),
            _Period: {
                Start: new Date(2018, 3, 22, 9, 15),
                Finish: new Date(2018, 3, 22, 10, 0)
            },
            _Repeat: {
                entityAspect: {
                    entityState: {
                        isModified: function () { return true; }
                    }
                }
            },
            _Twitter: 'piratenpartij',
            _Upload: 'https://s3.amazonaws.com/37assets/svn/1065-IMG_2529.jpg',
            _Url: 'https://www.piratenpartij.nl',
            _Xing: 'piratenpartij'
        };
        this.form = new FormGroup(this.controls);
    }
    FieldsetsAllComponent.prototype.getControl = function (name) {
        if (this.controls[name]) {
            return this.controls[name];
        }
        this.controls[name] = new FormControl();
        return this.controls[name];
    };
    return FieldsetsAllComponent;
}());
export { FieldsetsAllComponent };
/* tslint:enable */
